import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Pencil, Trash2, UserPlus, X } from "lucide-react";

const multi = (v) => ["responsabile", "area_manager"].includes(v.venditore_level);

// Modifica / elimina negozio
export function NegozioAzioni({ neg, onSaved }) {
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [f, setF] = useState(neg);
  useEffect(() => setF(neg), [neg]);
  const save = async () => {
    if (!(f.name || "").trim()) return toast.error("Il nome è obbligatorio");
    const { name, code, indirizzo, citta, telefono, email, active } = f;
    try {
      await api.put(`/negozi/${neg.id}`, { name, code, indirizzo, citta, telefono, email, active: active !== false });
      toast.success("Negozio aggiornato"); setOpen(false); onSaved();
    } catch (e) { toast.error(e.response?.data?.detail || "Salvataggio non riuscito"); }
  };
  const del = async () => {
    if (!window.confirm(`Eliminare il negozio "${neg.name}"? I venditori verranno sganciati, preventivi e commesse restano.`)) return;
    try { await api.delete(`/negozi/${neg.id}`); toast.success("Negozio eliminato"); nav("/adminnegozi"); }
    catch (e) { toast.error(e.response?.data?.detail || "Eliminazione non riuscita"); }
  };
  const F = (k, label) => <div><Label className="text-xs">{label}</Label><Input value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`neg-edit-${k}`} /></div>;
  return (<>
    <Button variant="outline" size="sm" onClick={() => setOpen(true)} data-testid="negozio-modifica"><Pencil className="h-4 w-4 mr-1" />Modifica</Button>
    <Button variant="outline" size="sm" onClick={del} className="text-rose-600 border-rose-200 hover:bg-rose-50" data-testid="negozio-elimina"><Trash2 className="h-4 w-4 mr-1" />Elimina</Button>
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-md" data-testid="negozio-edit-dialog">
        <DialogHeader><DialogTitle>Modifica negozio</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          {F("name", "Nome *")}{F("code", "Codice")}{F("indirizzo", "Indirizzo")}{F("citta", "Città")}{F("telefono", "Telefono")}{F("email", "Email")}
          <label className="flex items-center gap-2 text-sm col-span-2"><input type="checkbox" checked={f.active !== false} onChange={(e) => setF({ ...f, active: e.target.checked })} data-testid="neg-edit-active" />Negozio attivo</label>
        </div>
        <DialogFooter><Button variant="outline" onClick={() => setOpen(false)}>Annulla</Button><Button onClick={save} style={{ background: "var(--brand)", color: "white" }} data-testid="neg-edit-save">Salva</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  </>);
}

// Aggiunge un venditore esistente al negozio
export function AggiungiVenditore({ negId, presenti, onSaved }) {
  const [tutti, setTutti] = useState([]);
  const [sel, setSel] = useState("");
  useEffect(() => { api.get("/venditori").then((r) => setTutti(r.data || [])).catch(() => {}); }, [presenti.length]);
  const liberi = tutti.filter((v) => !presenti.includes(v.id));
  const add = async () => {
    const v = tutti.find((x) => x.id === sel); if (!v) return;
    try {
      await api.put(`/users/${v.id}`, multi(v) ? { negozi_ids: [...new Set([...(v.negozi_ids || []), negId])] } : { negozio_id: negId });
      toast.success(`${v.name} aggiunto al negozio`); setSel(""); onSaved();
    } catch (e) { toast.error(e.response?.data?.detail || "Operazione non riuscita"); }
  };
  return (
    <div className="flex items-center gap-2">
      <select value={sel} onChange={(e) => setSel(e.target.value)} className="h-8 text-xs border border-zinc-300 rounded px-1 bg-white" data-testid="negozio-add-vend-select">
        <option value="">Scegli un venditore…</option>
        {liberi.map((v) => <option key={v.id} value={v.id}>{v.name} ({v.email})</option>)}
      </select>
      <Button size="sm" onClick={add} disabled={!sel} data-testid="negozio-add-vend-btn"><UserPlus className="h-4 w-4 mr-1" />Aggiungi</Button>
    </div>
  );
}

export function TogliVenditore({ v, negId, onSaved }) {
  const go = async (e) => {
    e.stopPropagation();
    if (!window.confirm(`Togliere ${v.name} da questo negozio?`)) return;
    try {
      await api.put(`/users/${v.id}`, (v.negozi_ids || []).includes(negId) ? { negozi_ids: v.negozi_ids.filter((x) => x !== negId) } : { negozio_id: null });
      toast.success("Venditore tolto dal negozio"); onSaved();
    } catch (e) { toast.error(e.response?.data?.detail || "Operazione non riuscita"); }
  };
  return <button onClick={go} className="p-1 rounded hover:bg-rose-50 text-rose-600" title="Togli dal negozio" data-testid={`negozio-togli-${v.id}`}><X className="h-4 w-4" /></button>;
}
